import React from 'react';
import PropTypes from 'prop-types';
import MoneyBagIcon from '../../icons/icon-money-bag.svg';
import CustomReactMarkdown from '../MarkdownRenderers/CustomReactMarkdown';


const ProductInfoBanner = function ProductInfoBannerComponent({
  bannerClasses,
  theme,
  message,
}) {
  switch (theme) {
    case 'savings':
      return (
        <div className={`product-info-banner product-info-banner--savings ${bannerClasses}`}>
          <MoneyBagIcon className="money-bag-icon" />
          <div className="product-info-message-wrapper">
            <CustomReactMarkdown source={message} />
          </div>
        </div>
      );
    default:
      return (
        <div className={`product-info-banner ${bannerClasses}`}>
          <div className="product-info-message-wrapper">
            <CustomReactMarkdown source={message} />
          </div>
        </div>
      );
  }
};

ProductInfoBanner.propTypes = {
  message: PropTypes.string.isRequired,
  theme: PropTypes.string,
  bannerClasses: PropTypes.string,
};

ProductInfoBanner.defaultProps = {
  theme: undefined,
  bannerClasses: '',
};

export default ProductInfoBanner;
